"use client";

import { CountryCurrency, DEFAULT_CULTURE } from "@/app/interface/currency";
import React, { createContext, useContext, useState } from "react";

export type CultureContextType = {
    cultureContext: CountryCurrency;
    setCultureContext: React.Dispatch<React.SetStateAction<CountryCurrency>>;
};

const CultureContext = createContext<CultureContextType>({
    cultureContext: DEFAULT_CULTURE.US_STOCKS,
    setCultureContext: () => {},
});

export function Culture({ children }: { children: React.ReactNode }) {
    // const [isCultureLoading, setIsCultureLoading] = useState(true);
    const [cultureContext, setCultureContext] = useState<CountryCurrency>(
        DEFAULT_CULTURE.US_STOCKS,
    );

    return (
        <CultureContext.Provider value={{ cultureContext, setCultureContext }}>
            {children}
        </CultureContext.Provider>
    );
}

export function useCulture() {
    const context = useContext(CultureContext);
    if (context === undefined) {
        throw new Error("useAuth must be used within an AuthProvider");
    }
    return context;
}
